import type { CombinedError } from '@urql/core';
import type { AddressType, PinData, Region } from '@sweetgreen/garnish';

import type { ReorderRestaurantQuery } from '../../GraphQL/ReorderConfirmLocation.generated';
import { useReorderRestaurantQuery } from '../../GraphQL/ReorderConfirmLocation.generated';

export const useReorderConfirmLocationData = (
  restaurantId: string,
  orderType: AddressType,
): {
  readonly error?: CombinedError;
  readonly fetching: boolean;
  readonly restaurant?: ReorderRestaurantQuery['restaurant'];
  readonly region: Region;
  readonly pins: readonly PinData[];
} => {
  const [{ data, fetching, error }] = useReorderRestaurantQuery({
    variables: { id: restaurantId },
  });

  const restaurant = data?.restaurant;

  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  if (fetching || error || !data || !restaurant)
    return {
      error,
      fetching,
      restaurant: undefined,
      region: { lat: 0, lng: 0 },
      pins: [],
    };

  const region: Region = {
    lat: restaurant.latitude,
    lng: restaurant.longitude,
  };

  const pins: readonly PinData[] = [
    {
      id: restaurant.id,
      lat: restaurant.latitude,
      lng: restaurant.longitude,
      name: restaurant.name,
      isDeliveryAddress: orderType === 'delivery',
      acceptingOrders: restaurant.isAcceptingOrders,
      isOutpost: restaurant.isOutpost,
    },
  ];

  return {
    error,
    fetching,
    restaurant,
    region,
    pins,
  };
};
